<div class="card card-body d-flex flex-column ml-2 mr-2">
    <div class="d-flex flex-column ml-2 mr-2">
        <div class="d-flex align-items-center mb-2" style="width: 100px; height: auto;">
            <img src="{{integrationApp.iconUrl}}" alt="Integration App Icon" style="min-width: 40px;">
        </div>
        <span class="font-weight-bold">{{integrationApp.name}}</span>
        <span class="subinformations"
            [innerHTML]="'integration-apps-permission-card_display_vendor' | i18next: { vendor: integrationApp.vendor }"></span>
    </div>
    <hr>
    <p class="subinformations ml-2 mr-2">{{ (isUpgrade ? 'integration-apps-permission-card_resources_upgrade_info_text' : 
        'integration-apps-permission-card_resources_info_text') | i18next }}</p>
    <div class="d-flex flex-column flex-wrap gap-3 m-2">
        @for (res of integrationApp.appType?.pbxIntegrationApp?.resources; track $index) {
            <ng-container [ngTemplateOutlet]="resTemplateSwitch" [ngTemplateOutletContext]="{ $implicit: res }" ></ng-container>
        }
    </div>
    <div class="ml-2 mr-2 mt-5">
        <app-pascom-checkbox [text]=" 'integration-apps-permission-card_confirm_text' | i18next" (acceptChanged)="accept($event)"></app-pascom-checkbox>
    </div>
    <div class="align-self-end mt-3">
        <button class="btn btn-outline-white mr-2" (click)="onCancel()">{{ 'app_cancel' | i18next }}</button>
        <button class="btn btn-outline-primary" type="submit" (click)="continue()" [disabled]="!accepted">
            {{ (needsSecret ? 'app_next' : (isUpgrade ? 'integration_apps_upgrade_hint' : 'integration_apps_install_hint')) | i18next }}</button>
    </div>

</div>

<ng-template #resTemplateSwitch let-res>
    @switch (res.resource.$case) {
        @case ('label') {
            <ng-container [ngTemplateOutlet]="templateLabel" [ngTemplateOutletContext]="{ $implicit: res.resource[res.resource.$case] }"></ng-container>
        }
        @case ('aiAgent') {
            <ng-container [ngTemplateOutlet]="templateAiAgent" [ngTemplateOutletContext]="{ $implicit: res.resource[res.resource.$case] }"></ng-container>
        }
        @default {
            <ng-container [ngTemplateOutlet]="templateDefault" [ngTemplateOutletContext]="{ $implicit: res.resource }"></ng-container>
        }
    }
</ng-template>

<ng-template #templateLabel let-res>
    <div class="d-flex flex-row pr-4">
        <div>
            <i class="fa fa-tag mr-2"></i>
            @if (res.type === PbxLabel_Type.TYPE_GENERIC) {
                <span><b>{{ 'integration-apps-permission-card_generic_label_label' | i18next }}</b></span>
            } @else if (res.type === PbxLabel_Type.TYPE_SKILL) {
                <span><b>{{ 'integration-apps-permission-card_skill_label_label' | i18next }}</b></span>
            } @else {
                <span><b>{{ 'integration-apps-permission-card_label_label' | i18next }}</b></span>
            }
            <span class="ml-2">{{res.name}}</span>
        </div>
    </div>
</ng-template>
<ng-template #templateAiAgent let-res>
    <div class="d-flex flex-row pr-4">
        <div>
            <i class="fa fa-robot mr-2"></i>
            <span><b>{{ 'integration-apps-permission-card_ai_agent_label' | i18next }}</b></span>
            <span class="ml-2">{{res.name}}</span>
        </div>
    </div>
</ng-template>
<ng-template #templateDefault let-res>
    <div class="d-flex flex-row pr-4">
        <div>
            <i class="fa fa-box mr-2"></i>
            <span><b>{{res.$case}}:</b></span>
            <span class="ml-2">{{res[res.$case].name}}</span>
        </div>
    </div>
</ng-template>